// ============================================================================
// DAS TICKETS ENDPOINTS
// ============================================================================
// URL builders for DAS (Digital Approval System) API endpoints

import { buildEndpoint, buildEndpointWithParams, buildEndpointWithQuery } from './base.endpoints';
import type { ID } from '../types';

/**
 * DAS Tickets API Endpoints
 */
export const dasTicketEndpoints = {
  // List & Filter
  list: () => buildEndpoint('das/tickets'),
  myActiveItems: () => buildEndpoint('das/tickets/my-active-items'),
  myPendingApprovals: () => buildEndpoint('das/tickets/my-pending-approvals'),
  myCreatedRequests: () => buildEndpoint('das/tickets/created-by-me'),
  myCompletedInProgress: () => buildEndpoint('das/tickets/completed-in-progress'),
  myCompletedClosed: () => buildEndpoint('das/tickets/completed-closed'),
  escalatedToMe: () => buildEndpoint('das/tickets/escalated-to-me'),
  allTickets: () => buildEndpoint('das/tickets/all'),

  // Single Ticket
  getById: (id: ID) => buildEndpoint(`das/tickets/${id}`),
  getDetails: (id: ID) => buildEndpoint(`das/tickets/${id}/details`),

  // CRUD Operations
  create: () => buildEndpoint('das/tickets'),
  update: (id: ID) => buildEndpoint(`das/tickets/${id}`),
  delete: (id: ID) => buildEndpoint(`das/tickets/${id}`),

  // Actions
  approve: (id: ID) => buildEndpoint(`das/tickets/${id}/approve`),
  reject: (id: ID) => buildEndpoint(`das/tickets/${id}/reject`),
  recommend: (id: ID) => buildEndpoint(`das/tickets/${id}/recommend`),
  escalate: (id: ID) => buildEndpoint(`das/tickets/${id}/escalate`),
  returnForClarification: (id: ID) => buildEndpoint(`das/tickets/${id}/return`),
  addComment: (id: ID) => buildEndpoint(`das/tickets/${id}/comments`),

  // Attachments
  uploadAttachment: (id: ID) => buildEndpoint(`das/tickets/${id}/attachments`),
  downloadAttachment: (ticketId: ID, attachmentId: ID) =>
    buildEndpoint(`das/tickets/${ticketId}/attachments/${attachmentId}`),
  deleteAttachment: (ticketId: ID, attachmentId: ID) =>
    buildEndpoint(`das/tickets/${ticketId}/attachments/${attachmentId}`),

  // Workflow
  getWorkflowHistory: (id: ID) => buildEndpoint(`das/tickets/${id}/workflow-history`),
  getApprovalHierarchy: (id: ID) => buildEndpoint(`das/tickets/${id}/approval-hierarchy`),

  // Statistics
  getDashboardStats: () => buildEndpoint('das/dashboard/stats'),
  getMyStats: () => buildEndpoint('das/dashboard/my-stats'),

  // Search & Filter
  search: () => buildEndpoint('das/tickets/search'),
  advancedSearch: () => buildEndpoint('das/tickets/advanced-search'),
} as const;

export default dasTicketEndpoints;
